// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__2nAyA","savePackageButton":"ClientWallet_savePackageButton__94JCD"};